import  { useEffect,useState } from "react";
import homepage from "./assets/homepage.png";
import homefile from "./assets/homefile.png";
import homeqrobot from "./assets/homeqrobot.png";
import homebenchmarked from "./assets/homebenchmarked.png";
import surveySummary from "./assets/surveysummary.png";
import surveyDesign from "./assets/surveyDesign.png";
import surveyInputPanel from "./assets/surveyInputPanel.png";
import surveyQbank from "./assets/surveyQbank.png";
import surveyDesignOptions from "./assets/surveyDesignOptions.png";
import surveyDesignSections from "./assets/surveyDesignSections.png";
import collectOverview from "./assets/collectOverview.png";
import collectRecipientList from "./assets/collectRecipientList.png";
import collectImportRecipientList from "./assets/collectImportRecipientList.png";
import collectImportFromSurvey from "./assets/collectImportFromSurvey.png";
import collectEmailTemplate from "./assets/collectEmailTemplate.png";
import collectSchedule from "./assets/collectSchedule.png";
import surveyResults from "./assets/surveyResults.png";
import surveyInsight from "./assets/surveyInsight.png";
import { useSelector, useDispatch } from "react-redux";
const UserGuide = () => {
  const themeMode = useSelector((state) => state.themeMode);

  const [showScrollTop, setShowScrollTop] = useState(false);
  const SECTIONS = [
    { id: "home", label: "Home Page" },
    { id: "file", label: "Create from File" },
    { id: "qrobot", label: "QRobot" },
    { id: "benchmarked", label: "Benchmarked" },
    { id: "summary", label: "Summary" },
    { id: "design", label: "Design" },
    { id: "inputpanel", label: "Input Panel" },
    { id: "qbank", label: "QBank" },
    { id: "designoptions", label: "Right Menu - Options" },
    { id: "designsections", label: "Right Menu - Sections" },
    { id: "collect", label: "Collect Page" },
    { id: "collectimport", label: "Collect Import" },
    { id: "emailandschedule", label: "Email Template & Schedule" },
    { id: "results", label: "Survey Results" },
    { id: "insights", label: "Survey Insights" },
  ];
  const CardSection = ({ children, reverse = false }) => (
    <div
      className={`
      grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 
      border-b border-opacity-20 pb-4 sm:pb-6 lg:pb-8 mb-4 sm:mb-6 lg:mb-8
      ${themeMode === "dark" ? "border-white" : "border-black"}
      ${reverse ? "lg:grid-flow-dense" : ""}
    `}
    >
      {children}
    </div>
  );

  const ContentCard = ({ title, children, emoji }) => (
    <div
      className={`
      w-full p-4 sm:p-6 shadow-lg rounded-xl transition-all duration-300
      ${
        themeMode === "dark"
          ? "bg-[#282834] text-white hover:shadow-[0_0_1px_1px_#205DC2]"
          : "bg-white text-gray-800 hover:bg-gray-50 hover:shadow-[0_0_1px_1px_#205DC2]"
      }
    `}
    >
      <h1
        className={`
        text-xl sm:text-2xl font-bold mb-3 sm:mb-4
        ${themeMode === "dark" ? "text-white" : "text-gray-800"}
      `}
      >
        {emoji} {title}
      </h1>
      {children}
    </div>
  );

  const ImageContainer = ({ src, alt, className = "" }) => (
    <div className={`flex items-center justify-center ${className}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-auto max-w-full object-contain rounded-lg"
      />
    </div>
  );

  const SectionTitle = ({ children }) => (
    <h2
      className={`
      text-lg sm:text-xl font-semibold mt-4 sm:mt-6 mb-2 sm:mb-3
      ${themeMode === "dark" ? "text-white" : "text-gray-800"}
    `}
    >
      {children}
    </h2>
  );

  const Paragraph = ({ children }) => (
    <p
      className={`
      text-sm sm:text-base mb-3 sm:mb-4 leading-relaxed
      ${themeMode === "dark" ? "text-white" : "text-gray-700"}
    `}
    >
      {children}
    </p>
  );

  const List = ({ children, ordered = false }) => {
    const ListComponent = ordered ? "ol" : "ul";
    return (
      <ListComponent
        className={`
        ${
          ordered ? "list-decimal" : "list-disc"
        } pl-4 sm:pl-5 space-y-1 sm:space-y-2
        text-sm sm:text-base
        ${themeMode === "dark" ? "text-white" : "text-gray-700"}
      `}
      >
        {children}
      </ListComponent>
    );
  };
  useEffect(() => {
    const onScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleScrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleScrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // ... CardSection, ContentCard, ImageContainer, SectionTitle, Paragraph, List ...
  return (
    <div
      className={`
      w-full min-h-screen px-4 sm:px-6 lg:px-8 py-6 sm:py-8
      ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"}
    `}
    >
      <div className="max-w-7xl mx-auto space-y-6 sm:space-y-8 lg:space-y-12">
        {/* İçindekiler */}
<div
  className={`
    p-6 rounded-lg border mb-10
    ${themeMode === "dark"
      ? "bg-slate-900 border-slate-800 text-white"
      : "bg-white border-gray-200 text-gray-900"}
  `}
>
  <div className="mb-6">
     <h1
        className={`
        text-xl sm:text-2xl font-bold mb-3 sm:mb-4
        ${themeMode === "dark" ? "text-white" : "text-gray-800"}
      `}
      >Contents</h1>
    <p className={`text-sm ${themeMode === "dark" ? "text-gray-400" : "text-gray-500"}`}>
      Jump to section
    </p>
  </div>

  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
    {SECTIONS.map((sec) => (
      <button
        key={sec.id}
        className={`
          p-3 rounded-md text-left text-sm font-medium transition-colors
          ${themeMode === "dark" 
            ? "bg-slate-800 hover:bg-slate-700 text-gray-200" 
            : "bg-gray-100 hover:bg-gray-300 text-gray-700"
          }
        `}
        onClick={() => handleScrollTo(sec.id)}
      >
        {sec.label}
      </button>
    ))}
  </div>
</div>   {/* Home Page Section */}
        <div id="home">
          <CardSection>
            <ImageContainer
              src={homepage}
              alt="Homepage"
              className="order-2 lg:order-1"
            />
            <div className="order-1 lg:order-2">
              <ContentCard title="Home Page" emoji="📖">
                <Paragraph>
                  On our homepage, you will find <strong>Survey Card</strong>{" "}
                  components listing the surveys you have created. Through these
                  cards, you can perform various actions on the surveys.
                </Paragraph>

                <SectionTitle>📌 Survey Card Functions</SectionTitle>
                <List>
                  <li>
                    <strong>Create from Scratch:</strong> Creates a new blank
                    survey.
                  </li>
                  <li>
                    <strong>Clone:</strong> Creates an exact copy of an existing
                    survey.
                  </li>
                  <li>
                    <strong>Delete:</strong> Permanently deletes the survey.
                  </li>
                  <li>
                    <strong>Survey Summary:</strong> Clicking anywhere on the
                    card redirects you to a detailed summary page of the survey.
                  </li>
                  <li>
                    <strong>Survey Results:</strong> Clicking this button allows
                    you to view the completed responses and analyses of the
                    survey.
                  </li>
                  <li>
                    <strong>Insights:</strong> This button provides direct
                    access to insights derived from survey data.
                  </li>
                </List>

                <SectionTitle>🚀 Navigation and Access</SectionTitle>
                <Paragraph>
                  Using Survey Cards, you can perform quick actions and access
                  details. You can view survey statistics, analyses, and
                  summaries through the relevant buttons.
                </Paragraph>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* Create from File Section */}
        <div id="file">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="Create from File" emoji="📁">
                <Paragraph>
                  On the <strong>Create from File</strong> page, you can create
                  a survey by uploading your Excel (.xlsx) or JSON (.json)
                  files.
                </Paragraph>

                <SectionTitle>📌 File Formats</SectionTitle>
                <Paragraph>
                  To create a survey, the uploaded Excel or JSON file must
                  follow a specific format. If you need information about the
                  format:
                </Paragraph>
                <List>
                  <li>
                    Excel Template: Click the{" "}
                    <button className="text-blue-600 font-semibold mx-1">
                      Excel Template
                    </button>{" "}
                    button to access a sample Excel file.
                  </li>
                  <li>
                    JSON Template: Click the{" "}
                    <button className="text-blue-600 font-semibold mx-1">
                      JSON Template
                    </button>{" "}
                    button to download a sample JSON file.
                  </li>
                </List>

                <SectionTitle>🚀 Survey Upload Steps</SectionTitle>
                <List ordered>
                  <li>Prepare your Excel or JSON file.</li>
                  <li>Click the "Upload File" button and select your file.</li>
                  <li>
                    Once the upload is complete, you can create your survey.
                  </li>
                </List>
              </ContentCard>
            </div>
            <ImageContainer
              src={homefile}
              alt="Create from File"
              className="order-2 lg:order-1"
            />
          </CardSection>
        </div>
        {/* QRobot Section */},
        <div id="qrobot">
          <CardSection>
            <ImageContainer
              src={homeqrobot}
              alt="QRobot"
              className="order-2 lg:order-1"
            />
            <div className="order-1 lg:order-2">
              <ContentCard title="QRobot" emoji="🤖">
                <Paragraph>
                  QRobot is an AI-powered survey creation tool. By entering the
                  Survey Title, Description, and Topics fields, you can
                  automatically generate a survey using AI.
                </Paragraph>

                <SectionTitle>📌 Survey Creation Steps</SectionTitle>
                <List ordered>
                  <li>Fill in the Survey Title and Description fields.</li>
                  <li>Add relevant Topics or get AI-generated suggestions.</li>
                  <li>Automatically create your survey with AI.</li>
                </List>

                <SectionTitle>🚀 Topics Tab & Ask to AI Button</SectionTitle>
                <Paragraph>
                  By clicking the "Ask to AI" button in the Topics tab, you can
                  get AI-generated topic suggestions. This allows you to create
                  a more comprehensive and accurate survey.
                </Paragraph>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* Benchmarked Section */}
        <div id="benchmarked">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="Benchmarked" emoji="📊">
                <Paragraph>
                  On the Benchmarked page, you can create a new copy survey
                  using existing surveys. This way, you can create different
                  versions without modifying the original survey structure.
                </Paragraph>

                <SectionTitle>📌 How to Use?</SectionTitle>
                <List ordered>
                  <li>
                    Browse the available survey cards on the Benchmarked page.
                  </li>
                  <li>Click on the desired card to create a new survey.</li>
                  <li>
                    An exact copy of the selected survey will be generated.
                  </li>
                </List>

                <SectionTitle>🚀 Advantages</SectionTitle>
                <List>
                  <li>
                    Quickly create new surveys by referencing existing ones.
                  </li>
                  <li>No need to redesign the existing structure.</li>
                  <li>Manage your surveys more efficiently.</li>
                </List>
              </ContentCard>
            </div>
            <ImageContainer
              src={homebenchmarked}
              alt="Benchmarked"
              className="order-2 lg:order-1"
            />
          </CardSection>
        </div>
        {/* Summary Section */}
        <div id="summary">
          <CardSection>
            <ImageContainer
              src={surveySummary}
              alt="Survey Summary"
              className="order-2 lg:order-1"
            />
            <div className="order-1 lg:order-2">
              <ContentCard title="Summary" emoji="📊">
                <Paragraph>
                  The Summary page provides graphs and statistics to help you
                  analyze your survey.
                </Paragraph>

                <SectionTitle>📌 Page Content</SectionTitle>
                <List>
                  <li>
                    Response Time Chart: Shows when the survey was completed by
                    different users.
                  </li>
                  <li>
                    Completion Rate Chart: Displays the percentage of survey
                    completion.
                  </li>
                </List>

                <SectionTitle>📌 Right Menu Usage</SectionTitle>
                <Paragraph>
                  You can open the Right Menu using the icon in the top right
                  corner of the page. This menu provides quick access to survey
                  details:
                </Paragraph>
                <List>
                  <li>Status</li>
                  <li>Total Responses</li>
                  <li>Respondents</li>
                  <li>Create Date</li>
                  <li>Sections</li>
                  <li>Pages</li>
                  <li>Questions</li>
                  <li>End Date</li>
                  <li>Reset Survey Option</li>
                </List>

                <SectionTitle>🚀 Resetting the Survey</SectionTitle>
                <Paragraph>
                  You can reset the survey using the "Reset Survey" option in
                  the Right Menu. This action completely clears the survey
                  results and cannot be undone!
                </Paragraph>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* Design Section */}
        <div id="design">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="Design" emoji="🎨">
                <Paragraph>
                  The Design page allows you to create and customize your survey
                  by adding new sections, pages, and questions. You can also
                  edit or delete existing content.
                </Paragraph>

                <SectionTitle>📌 Adding New Content</SectionTitle>
                <List>
                  <li>Add new Sections to organize your survey.</li>
                  <li>
                    Insert new Pages to separate questions across different
                    screens.
                  </li>
                  <li>Add new Questions to design your survey content.</li>
                </List>

                <SectionTitle>📌 Editing Existing Content</SectionTitle>
                <List>
                  <li>
                    Modify or remove existing sections, pages, and questions.
                  </li>
                  <li>
                    Choose different question types to gather various response
                    formats.
                  </li>
                </List>

                <SectionTitle>📌 Question Types</SectionTitle>
                <Paragraph>
                  You can create various types of questions in your survey:
                </Paragraph>
                <List>
                  <li>Multiple Choice</li>
                  <li>Dropdown</li>
                  <li>Rating</li>
                  <li>Ranking</li>
                  <li>Text</li>
                  <li>Yes/No</li>
                </List>
              </ContentCard>
            </div>
            <ImageContainer
              src={surveyDesign}
              alt="Survey Design"
              className="order-2 lg:order-1"
            />
          </CardSection>
        </div>
        {/* Input Panel Section */}
        <div id="inputpanel">
          <CardSection>
            <ImageContainer
              src={surveyInputPanel}
              alt="Input Panel"
              className="order-2 lg:order-1"
            />
            <div className="order-1 lg:order-2">
              <ContentCard title="Input Panel" emoji="✏️">
                <Paragraph>
                  The Input Panel is located in the Left Menu of the Design
                  page. Here, you can add new questions to your survey.
                </Paragraph>

                <SectionTitle>📌 Adding Questions</SectionTitle>
                <List>
                  <li>
                    Click on an existing question type to add it directly to
                    your survey.
                  </li>
                  <li>
                    Newly added questions will be automatically inserted into
                    your survey design.
                  </li>
                </List>

                <SectionTitle>📌 Editing Questions</SectionTitle>
                <List>
                  <li>Select a question in the design page to edit it.</li>
                  <li>Modify the question type, text, and other settings.</li>
                </List>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    Choose the question type that best fits your survey goals.
                  </li>
                  <li>
                    You can always edit questions later to customize your
                    survey.
                  </li>
                </List>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* QBank Section */}
        <div id="qbank">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="QBank" emoji="📝">
                <Paragraph>
                  In the QBank section, you can view the questions of surveys
                  you have access to and add them directly to your survey.
                  Additionally, under the My Questions section, you can see the
                  questions you have created and add them to your survey.
                </Paragraph>

                <SectionTitle>📌 Viewing Existing Questions</SectionTitle>
                <List>
                  <li>
                    The questions of the surveys you have access to are listed
                    in the QBank menu.
                  </li>
                  <li>
                    To add these questions to your survey, simply click on the
                    question.
                  </li>
                </List>

                <SectionTitle>
                  📌 Viewing and Adding Your Own Questions
                </SectionTitle>
                <List>
                  <li>
                    You can find the questions you have created under the My
                    Questions section.
                  </li>
                  <li>
                    To add these questions to your survey, simply click on the
                    question.
                  </li>
                </List>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    When adding questions to your survey, make sure to select
                    questions that align with your survey goals.
                  </li>
                </List>
              </ContentCard>
            </div>
            <ImageContainer
              src={surveyQbank}
              alt="QBank"
              className="order-2 lg:order-1"
            />
          </CardSection>
        </div>
        {/* Right Menu Options Section */}
        <div id="designoptions">
          <CardSection>
            <ImageContainer
              src={surveyDesignOptions}
              alt="Design Options"
              className="order-2 lg:order-1"
            />
            <div className="order-1 lg:order-2">
              <ContentCard title="Right Menu - Options" emoji="⚙️">
                <Paragraph>
                  The Options section in the Right Menu allows you to customize
                  how your survey appears to users. You can personalize the
                  survey's appearance using the features below.
                </Paragraph>

                <SectionTitle>📌 Changing Settings</SectionTitle>
                <List>
                  <li>
                    Show Question Numbers: Enables numbering of survey questions
                    to indicate their sequence to users.
                  </li>
                  <li>
                    Questions on Page Mode: Defines whether questions appear in
                    the standard format or a different layout.
                  </li>
                  <li>
                    Show Progress Bar: Adds a progress bar to indicate how much
                    of the survey has been completed.
                  </li>
                  <li>
                    Progress Bar Type: Allows you to choose the type of progress
                    bar, such as a page-based progress indicator.
                  </li>
                  <li>
                    Show Page Titles: Displays the title of each survey page for
                    users.
                  </li>
                  <li>
                    Show Page Titles in the Progress Bar: Enables page titles to
                    appear within the progress bar for easier navigation.
                  </li>
                  <li>
                    Show Page Numbers in the Progress Bar: Displays page numbers
                    within the progress bar to indicate users' current page.
                  </li>
                </List>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    Elements like progress bars and page numbers can enhance
                    user experience.
                  </li>
                  <li>
                    Page titles and numbering help users follow the survey
                    structure more easily.
                  </li>
                  <li>
                    By utilizing appearance and layout options, you can ensure a
                    professional and user-friendly survey design.
                  </li>
                </List>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* Right Menu Sections Section */}
        <div id="designsections">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="Right Menu - Sections" emoji="📑">
                <Paragraph>
                  The Sections section in the Right Menu allows you to add new
                  pages and sections, delete existing ones, and rearrange the
                  pages and sections in your survey. With these options, you can
                  customize your survey as needed.
                </Paragraph>

                <SectionTitle>📌 Adding New Pages and Sections</SectionTitle>
                <List>
                  <li>
                    To add a new page or section, click the corresponding add
                    button in the right menu.
                  </li>
                  <li>
                    The added page or section will be inserted into your survey
                    at the appropriate position.
                  </li>
                </List>

                <SectionTitle>
                  📌 Deleting Existing Pages and Sections
                </SectionTitle>
                <List>
                  <li>
                    To delete an existing page or section, simply click the
                    delete button.
                  </li>
                  <li>
                    Once deleted, the page or section cannot be recovered, so
                    make sure before deleting.
                  </li>
                </List>

                <SectionTitle>📌 Reordering Pages and Sections</SectionTitle>
                <List>
                  <li>
                    You can reorder pages and sections using the Drag and Drop
                    method.
                  </li>
                  <li>
                    To move a page or section, click on it and drag it to the
                    desired position.
                  </li>
                </List>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    When rearranging pages and sections, ensure a logical order
                    for the flow of your survey.
                  </li>
                  <li>
                    Adding new sections can make your survey more comprehensive.
                  </li>
                  <li>
                    Deletion is irreversible, so double-check before removing
                    any pages or sections.
                  </li>
                </List>
              </ContentCard>
            </div>
            <ImageContainer
              src={surveyDesignSections}
              alt="Design Sections"
              className="order-2 lg:order-1"
            />
          </CardSection>
        </div>
        {/* Collect Page Section */}
        <div id="collect">
          <CardSection>
            <div className="flex flex-col space-y-4 sm:space-y-6 order-2 lg:order-1">
              <ImageContainer src={collectOverview} alt="Collect Overview" />
              <ImageContainer src={collectRecipientList} alt="Recipient List" />
            </div>
            <div className="order-1 lg:order-2">
              <ContentCard title="Collect Page" emoji="📥">
                <Paragraph>
                  The Collect Page allows you to share your surveys with users.
                  This page provides various options for sending surveys and
                  managing user information.
                </Paragraph>

                <SectionTitle>📌 Overview</SectionTitle>
                <Paragraph>
                  In the Overview section, you will find the list of users to
                  whom the survey has been sent. The status of users' surveys is
                  displayed here. You can track whether users have answered or
                  not from this section.
                </Paragraph>

                <SectionTitle>📌 Recipient List</SectionTitle>
                <Paragraph>
                  In the Recipient List section, you can add new users. By
                  entering user information, you can add new participants to the
                  survey.
                </Paragraph>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* Collect Import Section */}
        <div id="collectimport">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="Collect Page" emoji="📥">
                <SectionTitle>📌 Import from Recipient List</SectionTitle>
                <Paragraph>
                  With the Import from Recipient List option, you can upload
                  user data in Excel or CSV format. This feature is useful for
                  adding users in bulk.
                </Paragraph>

                <SectionTitle>📌 Import from Survey</SectionTitle>
                <Paragraph>
                  In the Import from Survey section, you can select a survey and
                  add the users from that survey to your new survey. You can
                  perform this action by clicking the import button.
                </Paragraph>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    Save time by adding users to the list in Excel or CSV
                    format.
                  </li>
                  <li>
                    The Recipient List and Import from Survey options simplify
                    user management for large surveys.
                  </li>
                </List>
              </ContentCard>
            </div>
            <div className="flex flex-col space-y-4 sm:space-y-6 order-2 lg:order-1">
              <ImageContainer
                src={collectImportRecipientList}
                alt="Import Recipient List"
              />
              <ImageContainer
                src={collectImportFromSurvey}
                alt="Import from Survey"
              />
            </div>
          </CardSection>
        </div>
        {/* Email Template and Schedule Section */}
        <div id="emailandschedule">
          <CardSection>
            <div className="flex flex-col space-y-4 sm:space-y-6 order-2 lg:order-1">
              <ImageContainer src={collectEmailTemplate} alt="Email Template" />
              <ImageContainer src={collectSchedule} alt="Schedule" />
            </div>
            <div className="order-1 lg:order-2">
              <ContentCard title="Collect Page" emoji="📥">
                <SectionTitle>📌 Email Template</SectionTitle>
                <Paragraph>
                  In the Email Template section, you can customize the template
                  for the survey invitation email. This allows you to modify the
                  subject, body, and design of the email that will be sent to
                  recipients.
                </Paragraph>

                <SectionTitle>📌 Schedule</SectionTitle>
                <Paragraph>
                  The Schedule section lets you select the start and end dates
                  for your survey. You can also send out the survey invitations
                  based on your chosen schedule.
                </Paragraph>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    Use the Email Template section to adjust the tone and style
                    of your survey invitation emails.
                  </li>
                  <li>
                    In the Schedule section, make sure to select the correct
                    dates to ensure the survey is sent at the right time.
                  </li>
                </List>
              </ContentCard>
            </div>
          </CardSection>
        </div>
        {/* Survey Results Section */}
        <div id="results">
          <CardSection reverse>
            <div className="order-1 lg:order-2">
              <ContentCard title="Survey Results" emoji="📊">
                <Paragraph>
                  The Survey Results page allows you to present the responses to
                  your survey visually and graphically. You can analyze which
                  answers users gave to each question and access detailed
                  statistics.
                </Paragraph>

                <SectionTitle>📌 Charts and Results</SectionTitle>
                <Paragraph>
                  On the Survey Results page, you can access charts that show
                  the percentages of answers given by users to each question.
                  These charts allow you to easily see which options are more
                  preferred.
                </Paragraph>

                <SectionTitle>
                  📌 Changing Questions with Previous/Next Buttons
                </SectionTitle>
                <Paragraph>
                  You can change the question displayed by using the Previous
                  and Next buttons. This allows you to step through the results
                  of each question one by one.
                </Paragraph>

                <SectionTitle>📌 User Select Filtering</SectionTitle>
                <Paragraph>
                  With the User Select filter, you can view responses from a
                  specific user. Using this filter, you can examine in detail
                  which option each user selected.
                </Paragraph>

                <SectionTitle>📌 Navigation</SectionTitle>
                <Paragraph>
                  On the left menu, there is a structure that shows the
                  hierarchy of sections, pages, and questions. Using this
                  structure, you can click on the desired section or page to be
                  directed to the first question of that section. Alternatively,
                  you can directly select a specific question to quickly access
                  its results.
                </Paragraph>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    Use the Prev/Next buttons to navigate through the questions
                    and review the responses for each question individually.
                  </li>
                  <li>
                    The User Select filter is very useful for viewing responses
                    from a specific user.
                  </li>
                  <li>
                    Use the section and page structures in the left menu to
                    quickly navigate and focus on specific questions.
                  </li>
                </List>
              </ContentCard>
            </div>
            <ImageContainer
              src={surveyResults}
              alt="Survey Results"
              className="order-2 lg:order-1"
            />
          </CardSection>
        </div>
        {/* Survey Insights Section */}
        <div id="insights">
          <CardSection>
            <ImageContainer
              src={surveyInsight}
              alt="Survey Insights"
              className="order-2 lg:order-1"
            />
            <div className="order-1 lg:order-2">
              <ContentCard title="Survey Insights" emoji="📊">
                <Paragraph>
                  The Survey Insights page allows you to view detailed analyses
                  and metrics of the report. On this page, you can examine the
                  score, maturity level, and key findings of the report.
                </Paragraph>

                <SectionTitle>📌 Report Maturity Level and Score</SectionTitle>
                <Paragraph>
                  On the Survey Insights page, you can get information about the
                  report's score and maturity level. These indicators help you
                  understand the overall status of the survey and its maturity
                  level.
                </Paragraph>

                <SectionTitle>📌 Left Menu: Reviews</SectionTitle>
                <Paragraph>
                  In the left menu of the page, you will see the reviews of the
                  report under different headings.
                </Paragraph>

                <SectionTitle>📌 Main Report: Export</SectionTitle>
                <Paragraph>
                  In the Main Report section, you can get the overall output of
                  the report. Here, you can view the entire report visually and
                  perform the necessary steps to export it.
                </Paragraph>

                <SectionTitle>🚀 Tips</SectionTitle>
                <List>
                  <li>
                    Click on the headings in the left menu to browse through
                    different sections of the report.
                  </li>
                  <li>
                    Check the score and maturity level indicators to understand
                    the overall status of the report.
                  </li>
                  <li>
                    To export the report, you can use the "Save as Pdf" button
                    in the Main Report section.
                  </li>
                </List>
              </ContentCard>
            </div>
          </CardSection>
        </div>
      </div>
       {showScrollTop && (
        <button
          onClick={handleScrollTop}
          className={`
            fixed bottom-8 right-8 z-50 p-3 rounded-full shadow-lg
            bg-blue-600 text-white hover:bg-blue-800 transition
          `}
          aria-label="Yukarı dön"
        >
          ↑
        </button>
      )}
    </div>
  );
};
export default UserGuide;
